import { formatHistoryDate } from "../lib/dates"
import { byNumber, byString } from "../lib/sorters"
import { ISkcHistoryRecord } from "../types/history.types"

const moneyColumn = (title: string, key: keyof ISkcHistoryRecord) => ({
  title,
  render: (row: ISkcHistoryRecord) => (row[key] == null ? "—" : `$${Number(row[key]).toFixed(2)}`),
  sorter: byNumber(key),
})

const dateColumn = (title: string, key: keyof ISkcHistoryRecord) => ({
  title,
  render: (row: ISkcHistoryRecord) => formatHistoryDate(row[key] as string),
  sorter: byString(key),
})

const formatPlacements = (items: Array<[string, unknown]>) =>
  items
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([label, value]) => `${label}: ${value}%`)
    .join(" | ") || "—"

const SKC_HISTORY_COLUMNS = [
  {
    title: "Campaign Name",
    render: (row: ISkcHistoryRecord) => row.campaignName,
    sorter: byString("campaignName"),
  },
  {
    title: "Target Name",
    render: () => "Base bid",
  },
  moneyColumn("Bid Before", "oldBid"),
  moneyColumn("Bid After", "newKeywordBid"),
  {
    title: "Placements Before",
    render: (row: ISkcHistoryRecord) =>
      formatPlacements([
        ["TOS", row.old_TOS_modifire],
        ["ROS", row.old_ROS_modifire],
        ["PP", row.old_PP_modifire],
        ["AB", row.old_AB_modifire],
        ["AD", row.old_AD_modifire],
        ["FV", row.old_FV_modifire],
      ]),
  },
  {
    title: "Placements After",
    render: (row: ISkcHistoryRecord) =>
      formatPlacements([
        ["TOS", row.TOS_modifire],
        ["ROS", row.ROS_modifire],
        ["PP", row.PP_modifire],
        ["AB", row.AB_modifire],
        ["AD", row.AD_modifire],
        ["FV", row.FV_modifire],
      ]),
  },
  dateColumn("Updated At", "updatedAt"),
]

const useSkcHistoryColumns = () => SKC_HISTORY_COLUMNS

export default useSkcHistoryColumns
